/**
 * PortOne (구 아임포트) 결제 설정
 * 환경 변수에서 값을 읽어옵니다
 */

export const PORTONE_CONFIG = {
  storeId: process.env.REACT_APP_PORTONE_STORE_ID || 'store-50c68aa6-6546-4d7b-9cb0-fe985c250814',
  channelKey: process.env.REACT_APP_PORTONE_CHANNEL_KEY || 'channel-key-8ac955da-ddb9-4a2e-bd76-7fe28f90b4ac',
};

// 프로덕션 환경에서 기본값 사용 경고
if (process.env.NODE_ENV === 'production') {
  if (!process.env.REACT_APP_PORTONE_STORE_ID || !process.env.REACT_APP_PORTONE_CHANNEL_KEY) {
    console.warn('⚠️ PortOne credentials are using default values. Please set environment variables.');
  }
}
